var _module_exports = "<div class=\"main-dashboard\">\n  <br />\n<div class=\"container\">\n  <div class=\"dashboard-cards \">\n    <div class=\"row\">\n      <div class=\" col-sm-3\">\n        <savings-status-card r=\"50\" game-info=\"savings\"></savings-status-card>\n      </div>\n      <div class=\" col-sm-6\">\n        <savings-card savings=\"savings\"></savings-card>\n      </div>\n      <div class=\"text-center col-sm-3\">\n        <my-cause-card my-cause=\"myCause\" savings=\"savings\"></my-cause-card>\n      </div>\n    </div>\n  </div>\n\n</div>\n<div entry-popup></div>\n</div>\n";;
var path = '/containers/dashboard/views/sections/dashboard.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./js/containers/dashboard/views/sections/dashboard.html
// module id = 716
// module chunks = 0